import React from 'react';
import { Wrapper } from './styles';
export const ArrowDown = props => {
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement("svg", { width: "20", height: "11", viewBox: "0 0 20 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("line", { y1: "-1", x2: "12.7279", y2: "-1", transform: "matrix(0.707107 0.707107 0.707107 -0.707107 2 0)", stroke: "#355C7E", strokeWidth: "2" }),
            React.createElement("line", { x1: "18.7071", y1: "0.707107", x2: "9.70711", y2: "9.70711", stroke: "#355C7E", strokeWidth: "2" }))));
};
